import React, { memo } from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { ServiceHero } from '../components/ServiceHero';
import { ServiceContactForm } from '../components/ServiceContactForm';
import { CheckCircleIcon } from 'lucide-react';
export function DementiaCare() {
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-930">
      <Navbar data-id="element-931" />
      <main className="flex-1" data-id="element-932">
        <ServiceHero badge="Care Solutions" title="Dementia Care" subtitle="Specialized memory care with person-centred approaches that preserve dignity and quality of life." imageUrl="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=1600&auto=format&fit=crop" data-id="element-933" />

        <div className="max-w-4xl mx-auto px-4 py-16 lg:py-24" data-id="element-934">
          <div className="prose prose-lg max-w-none text-text-muted leading-relaxed space-y-6" data-id="element-935">
            <p data-id="element-936">
              Our Dementia Care services provide specialized memory care from
              workers trained in dementia and Alzheimer's support. We focus on
              person-centered approaches that preserve dignity, promote
              independence, and enhance the quality of life for individuals
              living with dementia.
            </p>
            <p data-id="element-937">
              Our caregivers are trained to manage behavioral symptoms, provide
              safe wandering prevention, and offer caregiver respite and relief.
              Every care plan is nurse-supervised, ensuring the highest
              standards of clinical quality and patient safety.
            </p>
          </div>

          <div className="mt-12 bg-gray-50 rounded-2xl p-8 border border-gray-100" data-id="element-938">
            <h3 className="text-2xl font-bold text-text-dark mb-6" data-id="element-939">
              Our Approach to Memory Care
            </h3>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-940">
              {["Specialized Alzheimer's & dementia training", 'Behavioral symptom management techniques', 'Safe wandering prevention & home safety', 'Cognitive stimulation & engaging activities', 'Caregiver respite & family support', 'Consistent routines to reduce anxiety'].map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-941">
                  <CheckCircleIcon className="w-6 h-6 text-accent-teal flex-shrink-0 mt-0.5" data-id="element-942" />
                  <span className="text-text-dark font-medium" data-id="element-943">{feature}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <ServiceContactForm serviceName="Dementia Care" data-id="element-944" />
      </main>
      <StickyFooter data-id="element-945" />
    </div>;
}